<template>
  <div>
    <div class="py-1 bg-gray-200 shadow w-full flex justify-between items-center">
      <div class="px-4">
        <p-check class="p-icon p-plain text-gray-700" toggle v-model="isNotExpiredFilter" @change="fetchData()">
          <i class="icon far fa-calendar" slot="extra"></i>
          kommende
          <i class="icon far fa-calendar-check" slot="off-extra"></i>
          <label slot="off-label">abgelaufene</label>
        </p-check>
      </div>
      <div class="px-4">
        <p-check class="p-icon p-plain text-gray-700" toggle v-model="noUbvFilter" @change="fetchData()">
          <i class="icon fas fa-user-slash" slot="extra"></i>
          ohne UBV
          <i class="icon fas fa-user-tie" slot="off-extra"></i>
          <label slot="off-label">UBV</label>
        </p-check>
      </div>
      <div class="px-4">
        <input class="mx-1 input" @change="fetchData()" v-model="courtFilter" placeholder="Gericht"/>
      </div>
      <div class="px-4" v-if="!!dossierId">
        <trial-create-form-modal :trial="{dossier_id: dossierId, date: null}" v-on:updated="updated" />
      </div>
    </div>
    <table class="table-auto shadow w-full">
      <tr v-for="trial in this.trials" v-bind:key="trial.id">
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left" v-if="!dossierId">
          <a :href="trial.dossier_path" class="primary-link">
            <i class="fas fa-folder-open"></i> {{ trial.dossier_name }}
          </a>
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left">
          <accordion :title="trial.title" :active="false" title-classes="text-black"
                     active-title-classes="font-bold">
            <div class="text-gray-900 py-2 whitespace-pre-line">
              {{ trial.description }}
            </div>
            <div class="flex">
              <div @click="edit(trial)" class="btn btn-secondary btn-small inline-block my-2 mr-2 cursor-pointer">
                <i class="fas fa-edit"></i>
                bearbeiten
              </div>
              <div @click="remove(trial)" class="btn btn-remove btn-small inline-block my-2 cursor-pointer">
                <i class="far fa-trash-alt"></i>
                löschen
              </div>
            </div>
          </accordion>
          <div v-if="trial.ubv">
            <span class="text-sm text-green-600">
              <i class="far fa-check-circle mr-1"></i>
            </span>
            <span class="text-sm text-gray-600">
              {{ trial.ubv }}
            </span>
          </div>
          <div v-else>
            <span class="text-red-500 text-sm">
              <i class="far fa-times-circle ml-1"></i>
            </span>
            <span class="text-sm text-gray-600">
              kein UBV
            </span>
          </div>
          <trial-edit-form-modal :trial="trial" v-on:updated="updated()"/>
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left">
          {{ trial.date | toDate }}
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left">
          {{ trial.time }}
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left">
          {{ trial.court_name }}
        </td>

        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-right">
          <div class="flex justify-end">
            <div @click="edit(trial)" class="btn btn-secondary btn-small mr-2">
              <i class="fas fa-edit"></i>
            </div>
          </div>
        </td>

      </tr>
    </table>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ['dossierId'],
  data() {
    return {
      isNotExpiredFilter: true,
      noUbvFilter: false,
      courtFilter: '',
      trials: [],
    }
  },
  filters: {
    toDate: function(value, format = 'DD.MM.YYYY') {
      if (value == null) {
        return value;
      }
      return moment(value).format(format);
    }
  },
  methods: {
    fetchData: function () {
      this.$http['get']('/trials.json', {
        params: {
          dossier_id: this.dossierId,
          expired: !this.isNotExpiredFilter,
          no_ubv: this.noUbvFilter,
          court_name: this.courtFilter,
        }
      }).then(response => {
        console.log(response.body)
        this.trials = response.body
        this.$forceUpdate()
      }, response => {
        console.log(response)
      })
    },
    edit: function (trial) {
      this.$modal.show('trial-form-modal-'+trial.id);
    },
    remove: function (trial) {
      this.$confirm(
          {
            message: `Wirklich unwiderruflich 🙈🙈🙈 löschen?`,
            button: {
              no: 'Abbrechen',
              yes: 'Löschen'
            },
            callback: confirm => {
              if (confirm) {
                this.$http['delete']('/trials/'+trial.id).then(response => {
                  this.fetchData();
                  this.$forceUpdate();
                  Vue.$toast.success('Gerichtstermin wurde entfernt.')
                }, response => {
                })
              }
            }
          }
      )
    },
    updated: function (event) {
      this.fetchData();
      this.$forceUpdate();
    },
  },
  mounted() {
    this.fetchData();
  }
}
</script>